var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 436,
    height: 403,
    viewBox: "0 0 436 403",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.695 24.9017C136.695 24.9017 62.5311 61.5747 25.5421 118.08C-11.4468 174.586 -8.52019 247.258 36.4264 301.189C81.373 355.121 167.283 348.083 239.215 382.277C311.147 416.471 390.508 409.423 424.522 337.007C458.535 264.592 407.246 237.493 398.437 153.709C389.627 69.9238 311.783 -52.7472 136.695 24.9017Z",
    fill: "#132F2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector8);
export default __webpack_public_path__ + "static/media/Vector (8).2a70047e69c789a8d77626daa5d85bd0.svg";
export { ForwardRef as ReactComponent };